import { Alert, Button, Divider, Form, Input, Select, Switch } from "antd";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { responseNotification } from "../../../utils/notify";
import styles from "../../../styles/tailwind/Add.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCropAlt, faXmark } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import axios from "axios";
import { debounce } from "lodash";
import { useParams } from "react-router";

const AddProductURl = ({ visibleData, onCloseMethod }: any) => {
  const { type, token } = useSelector((state) => (state as any)?.authReducer);
  const route = useParams();
  const [startUpload, setStartUpload] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >();
  const shopId = (route as any)?.shopId;
  const [error, setError] = useState("");
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [productUrlData, setProductUrlData] = useState<any>(undefined);
  const [bannerType, setBannerType] = useState<any>(null);
  const [serviceType, setServiceType] = useState<any>(null);
  const [shopSlug, setShopSlug] = useState<any>();
  const [typeId, setTypeId] = useState<any>();

  const [key, setKey] = useState("");
  const [dataOptions, setDataOptions] = useState({
    loading: false,
    list: [],
  });

  useEffect(() => {
    if (startUpload === "Uploaded") {
      form.submit();
    }
  }, [form, startUpload]);

  const onSubmit = async (data: any) => {
    setLoading(true);
    const readyData = data && {
      productUrl: data.productUrl,
      shopId: shopId,
    };
    await fetch(
      `${process.env.REACT_APP_CATALOG_WRITER_API}/affiliate-product`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification("Url Generate Successfully", "success");
          form.resetFields();
          if (onCloseMethod) {
            onCloseMethod();
          }
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const getProductOptions = useCallback(
    async (key: any) => {
      setDataOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      let url =
        `?page=0&limit=20` +
        (serviceType ? `&type=${serviceType}` : `&type=${type}`) +
        (key ? `&key=${key}` : ``);
      url = encodeURI(url);

      return axios
        .get(`${encodedUri}/admin/product/search${url}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setDataOptions({
            loading: false,
            list: res.data?.keys?.map((product: { name: any; slug: any }) => ({
              label: product.name,
              value: product.slug,
            })),
          });
        })
        .catch((err) => {
          setDataOptions({ loading: false, list: [] });
          console.error("Products: Error", err);
        });
    },
    [key, serviceType]
  );

  const getShopOptions = useCallback(
    async (key: any) => {
      setDataOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      return axios
        .get(
          `${encodedUri}/shop/admin/search?page=0&limit=20` +
            (serviceType ? `&type=${serviceType}` : `&type=${type}`) +
            (key ? `&key=${key}` : ``),
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          setDataOptions({
            loading: false,
            list: res.data?.shops?.map((shop: any) => ({
              label: shop?.name,
              value: shop?.slug,
            })),
          });
        })
        .catch((err) => {
          setDataOptions({ loading: false, list: [] });
          console.error("Categories: Error", err);
        });
    },
    [type, serviceType]
  );

  const getBrandsOptions = useCallback(
    async (key?: string) => {
      setDataOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      const res = await axios.get(
        `${encodedUri}/brand/search?page=0&limit=20` +
          (serviceType ? `&type=${serviceType}` : `&type=${type}`) +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setDataOptions({
        loading: false,
        list: res?.data?.brands?.map((brand: any) => ({
          label: brand.name,
          value: brand.slug,
        })),
      });
    },
    [serviceType]
  );

  const getCampaignOptions = useCallback(async (key?: string) => {
    setDataOptions({ loading: true, list: [] });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    const res = await axios.get(
      `${encodedUri}/admin/campaign/by-type` +
        (serviceType ? `?type=${serviceType}` : `?type=${type}`),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setDataOptions({
      loading: false,
      list: res?.data?.campaigns?.map((campaign: any) => ({
        label: campaign.name,
        value: campaign.slug,
      })),
    });
  }, []);

  useEffect(() => {
    if (visibleData) {
      setProductUrlData(visibleData);
    }
  }, [visibleData]);

  useEffect(() => {
    if (productUrlData) {
      form.resetFields(Object.keys(visibleData));
    }
  }, [productUrlData, form, visibleData]);

  const fetchRef = useRef(0);
  const handleSearch = useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "products") getProductOptions(value);
        else if (field === "shops") getShopOptions(value);
        else if (field === "brands") getBrandsOptions(value);
        else if (field === "campaigns") getCampaignOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getProductOptions, getShopOptions, getBrandsOptions, getCampaignOptions]);

  useEffect(() => {
    if (bannerType === "PRODUCTS") {
      getProductOptions(``);
    }
  }, [bannerType, serviceType]);

  useEffect(() => {
    if (bannerType === "CAMPAIGNS") {
      getCampaignOptions();
    }
  }, [bannerType, serviceType]);

  useEffect(() => {
    if (bannerType === "BRANDS") {
      getBrandsOptions();
    }
  }, [bannerType, serviceType]);

  useEffect(() => {
    if (bannerType === "SHOPS") {
      getShopOptions(``);
    }
  }, [bannerType, serviceType]);

  return (
    <>
      <Form
        name="control-hooks"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        className={styles.formStyles}
        onFinish={onSubmit}
        form={form} // like ref
        layout="vertical"
        initialValues={{
          ...productUrlData,
        }}
      >
        <Form.Item
          hasFeedback
          label="Product URL"
          rules={[
            {
              required: true,
              message: "URL is Required!",
            },
          ]}
          name="productUrl"
        >
          <Input id="productUrl" type="text" placeholder="Enter Product URL" />
        </Form.Item>
        <div className="buttons-container">
          <Button
            disabled={loading || !!error}
            loading={(loading ? "loading" : undefined) as any}
            type="primary"
            htmlType="submit"
            className="add-submit-btn text-center mr-2"
          >
            Submit
          </Button>

          <Button
            htmlType="button"
            onClick={() => {
              form?.resetFields();
            }}
            className="reset-submit-btn text-center mr-2"
          >
            Reset
          </Button>
        </div>
      </Form>
    </>
  );
};

export default AddProductURl;
